import { UserTypes } from './types';

export const userTypes: UserTypes = {
  EMPLOYEE: {
    type: 'employee',
    steps: [
      'selectuser',
      'selectproduct',
    ],
    selectedUser: '',
    selectedProducts: [],
  },
  CUSTOMER: {
    type: 'customer',
    steps: [
      'default',
    ],
  },
};

export const CUSTOMER: string = 'CUSTOMER';
export const EMPLOYEE: string = 'EMPLOYEE';
